import React from 'react'

const bootstrapColGenerator = (col_width) => {
    return col_width? `col-md-${col_width}`: "col-md-3"
}

const Search = ({ search, onSearchChange, onClear, searchBarWidth }) => {
    /*let search_timer_id = -1;
    const onSearchKeyUp = (e) => {
        clearTimeout(search_timer_id);
        search_timer_id = setTimeout(() => {
            onSearchChange(e)
            setTimeout(() => {
                e.target.value="";
            }, 100)
        }, 500)
    }*/

    return (
        <div className={bootstrapColGenerator(searchBarWidth)}>
            <div className="form-group">
                <div className="input-group">
                    <input
                        id="search"
                        name="search"
                        placeholder="Search"
                        className="form-control searchField"
                        onChange={onSearchChange}
                        value={search}
                    />
                    <div className="input-group-append">
                        <button
                            className={
                                search
                                    ? 'btn btn-outline-danger btn-search'
                                    : 'btn btn-outline-dark btn-search'
                            }
                            type="button"
                            style={{
                                borderWidth: 0.5,
                                borderColor: '#ccc',
                                borderLeftWidth: 0,
                            }}
                            onClick={onClear} >
                            <i className={search ? 'fa fa-times' : 'fa fa-search'} />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Search